"use client";

import { useEffect, useRef, useState, CSSProperties } from 'react';
import { getRandomNumber } from '@/helpers/helperFunctions';
import { GameModel, ProjectModel } from '@/db/schema';
import { isMobile } from 'react-device-detect';
import {
    MySkillsOnAIAndAutonomousAgents,
    MySkillsOnCloudAndDevOps,
    MySkillsOnDatabases,
    MySkillsOnFrameworksAndLibraries,
    MySkillsOnOtherTechnologies,
    MySkillsOnProgramming,
    MySkillsOnWebTechnologies
} from '@/components/Skills';
import Link from 'next/link';
import Slider from 'react-slick';
import AnimatedTextWriter from 'react-animated-text-writer';
import SvgIcons from '@/components/SvgIcons';
import useUserAuthentication from '@/helpers/useUserAuthentication';
import LoadGameComponent from '@/games/components/LoadGameComponent';
import SolarSync from '@/projects/SolarSync/SolarSync';
import ToptalHireMe from '@/components/ToptalHireMe';
import '@/games/components/LoadGameComponent.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const thumbImages = [
    {
        organization: 'Banglalink Digital Communications Ltd',
        url: 'banglalink',
        size: 12,
        class: '',
        images: [
            { thumb: 'experience/work/banglalink/dss-manager-01.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=0&maximized=true', title: 'Certificate of Recognition from our CEO' },
            { thumb: 'experience/work/banglalink/dss-manager-04.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=3&maximized=true', title: 'Customer First — achievement unlocked!'},
            { thumb: 'experience/work/banglalink/dss-manager-05.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=4&maximized=true', title: 'Bioshakh 1426 Celebration'},
            { thumb: 'experience/work/banglalink/dss-manager-06.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=5&maximized=true', title: 'Family Night Program 2019'},
            { thumb: 'experience/work/banglalink/dss-manager-07.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=6&maximized=true', title: 'Banalalink Safety and Wellness Week, 2022'},
            { thumb: 'experience/work/banglalink/dss-manager-08.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=7&maximized=true', title: 'Bioshakh 1426 Celebration'},
            { thumb: 'experience/work/banglalink/dss-manager-09.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=8&maximized=true', title: 'Bioshakh 1426 Celebration'},
            { thumb: 'experience/work/banglalink/dss-manager-11.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=10&maximized=true', title: 'Bioshakh 1426 Celebration'},
            { thumb: 'experience/work/banglalink/dss-manager-12.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=11&maximized=true', title: 'Bioshakh 1426 Celebration'},
            { thumb: 'experience/work/banglalink/dss-manager-13.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=12&maximized=true', title: 'Farewell of Interns'},
            { thumb: 'experience/work/banglalink/dss-manager-14.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=13&maximized=true', title: 'Random'},
            { thumb: 'experience/work/banglalink/dss-manager-16.webp', url: 'work/banglalink-digital-solution-and-service-manager?index=15&maximized=true', title: 'Farewell of Sohail Bhai'},
            { thumb: 'experience/work/banglalink/it-manager-05.webp', url: 'work/banglalink-it-manager?index=4&maximized=true', title: 'Selfie with CEO'},
            { thumb: 'experience/work/banglalink/it-manager-07.webp', url: 'work/banglalink-it-manager?index=6&maximized=true', title: 'IT Pitha Utsab 2017'},
            { thumb: 'experience/work/banglalink/it-manager-08.webp', url: 'work/banglalink-it-manager?index=7&maximized=true', title: 'Team Lunch'},
            { thumb: 'experience/work/banglalink/it-manager-09.webp', url: 'work/banglalink-it-manager?index=8&maximized=true', title: 'Team Lunch with Nazib Bhai'},
            { thumb: 'experience/work/banglalink/it-manager-10.webp', url: 'work/banglalink-it-manager?index=9&maximized=true', title: 'Team Lunch with old Boss'},
            { thumb: 'experience/work/banglalink/it-manager-11.webp', url: 'work/banglalink-it-manager?index=10&maximized=true', title: 'Good times, great company.'},
            { thumb: 'project/inms/inms-currently-down-sites-dashboard.webp', url: 'project/inms?index=0&maximized=true', title: 'Currently Down Sites on Map - INMS.'},
            { thumb: 'project/minsat-crm-system/minsat-view.webp', url: 'project/minsat-crm-system?index=0&maximized=true', title: 'MinSat CRM.'},
        ]
    },
    {
        organization: 'OrangeToolz',
        url: 'orangetoolz',
        size: 12,
        class: '',
        images: [
            { thumb: 'experience/work/orangetoolz/20230830_140256.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=5&maximized=true', title: 'Farewell of Aoyan'},
            { thumb: 'experience/work/orangetoolz/20230815_180536.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=4&maximized=true', title: 'Football Match'},
            { thumb: 'experience/work/orangetoolz/20231019_151727.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=6&maximized=true', title: 'Random Selfie'},
            { thumb: 'experience/work/orangetoolz/20240210_103240.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=9&maximized=true', title: 'Bike Tour'},
            { thumb: 'experience/work/orangetoolz/20240224_182427.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=10&maximized=true', title: 'Workaholics on Saturday'},
            { thumb: 'experience/work/orangetoolz/20240517_141108.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=12&maximized=true', title: 'Post-Work Pizza Party Courtesy of Our CEO'},
            { thumb: 'experience/work/orangetoolz/20240517_141140.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=13&maximized=true', title: 'Post-Work Pizza Party Courtesy of Our CEO'},
            { thumb: 'experience/work/orangetoolz/20240517_141223.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=14&maximized=true', title: 'Post-Work Pizza Party Courtesy of Our CEO'},
            { thumb: 'experience/work/orangetoolz/20240517_141302.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=15&maximized=true', title: 'Post-Work Pizza Party Courtesy of Our CEO'},
            { thumb: 'experience/work/orangetoolz/20240517_141334.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=16&maximized=true', title: 'Post-Work Pizza Party Courtesy of Our CEO'},
            { thumb: 'experience/work/orangetoolz/20240613_203941.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=19&maximized=true', title: 'A well-deserved treat from our CEO in celebration of the team\'s achievements'},
            { thumb: 'experience/work/orangetoolz/20240613_204045.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=20&maximized=true', title: 'A well-deserved treat from our CEO in celebration of the team\'s achievements'},
            { thumb: 'experience/work/orangetoolz/20240710_133503.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=23&maximized=true', title: 'Better late than never! Thanks to Nahid for the delicious kickoff to his married life!'},
            { thumb: 'experience/work/orangetoolz/20240614_183955.webp', url: 'work/orangetoolz-solution-architect-senior-manager?index=21&maximized=true', title: 'Beloved Team Members'},
            { thumb: 'project/weekly-update-monitor-and-report-automation/af-weekly-update-dashboard.webp', url: 'project/weekly-update-monitor-and-report-automation?index=0&maximized=true', title: 'Weekly Update Monitor & Report Automation'},
            { thumb: 'project/wordpress-fixed-version-plugin-status-checker/web-utility-plugin-dashboard.webp', url: 'project/wordpress-fixed-version-plugin-status-checker?index=0&maximized=true', title: 'WordPress Fixed Version Plugin Status Checker'},
            { thumb: 'project/wordpress-content-change-monitor-and-workflow-automation/activity-log.webp', url: 'project/wordpress-content-change-monitor-and-workflow-automation?index=0&maximized=true', title: 'WordPress Content Change Monitor & Workflow Automation'},
            { thumb: 'project/human-resource-management-hrm-solution/hrm-solution-login.webp', url: 'project/human-resource-management-hrm-solution?index=0&maximized=true', title: 'Human Resource Management (HRM) Solution'},
            { thumb: 'project/automated-404-error-detection-tool/slack-message.webp', url: 'project/automated-404-error-detection-tool?index=0&maximized=true', title: 'Automated 404 Error Detection Tool'},
            { thumb: 'project/page-speed-performance-monitoring-automation/slack-integration-with-commands.webp', url: 'project/page-speed-performance-monitoring-automation?index=0&maximized=true', title: 'Page Speed Performance Monitoring Automation'},

        ]
    },
    {
        organization: 'Islamic University of Technology',
        url: 'iut',
        size: 12,
        class: '',
        images: [
            { thumb: 'experience/education/iut/2009-11-04-msc-convocation.webp', url: 'education/msc?index=0&maximized=true', title: 'MSc. Convocation'},
            { thumb: 'experience/education/iut/2004-08-31-programming-contest-champion-01.webp', url: 'education/bsc?index=0&maximized=true', title: 'Programming Contest Champion'},
            { thumb: 'experience/education/iut/2004-08-31-programming-contest-champion-02.webp', url: 'education/bsc?index=1&maximized=true', title: 'Programming Contest Champion'},
            { thumb: 'experience/education/iut/2004-departmental-picnic-01.webp', url: 'education/bsc?index=2&maximized=true', title: 'Departmental Picnic 01'},
            { thumb: 'experience/education/iut/2004-departmental-picnic-04.webp', url: 'education/bsc?index=5&maximized=true', title: 'Departmental Picnic'},
            { thumb: 'experience/education/iut/2004-08-31-programming-contest-champion-hangout-01.webp', url: 'education/bsc?index=10&maximized=true', title: 'Hangout with Friends'},
            { thumb: 'experience/education/iut/2004-08-31-programming-contest-champion-hangout-02.webp', url: 'education/bsc?index=11&maximized=true', title: 'Hangout with Friends'},
            { thumb: 'experience/education/iut/2005-09-12-group-photo-01.webp', url: 'education/bsc?index=12&maximized=true', title: 'Group Photo'},
            { thumb: 'experience/education/iut/2005-09-12-group-photo-02.webp', url: 'education/bsc?index=13&maximized=true', title: 'Group Photo'},
            { thumb: 'experience/education/iut/2006-12-26-msc-dormitory.webp', url: 'education/msc?index=1&maximized=true', title: 'MSc. Dormitory'},
            { thumb: 'experience/education/iut/2007-01-12-msc-dormitory.webp', url: 'education/msc?index=2&maximized=true', title: 'MSc. Dormitory'},
            { thumb: 'project/iutcafe/iutcafe-messenger-result-viewer-03.webp', url: 'project/iutcafe/?index=8&maximized=true', title: 'Result Viewer - IUTCafe'},
            { thumb: 'project/virus-removal-win32.chir.b/virus-removal-win32.chir.b-01.png', url: 'project/chir_b-virus-removal/?index=0&maximized=true', title: 'Virus Removal Win32.Chir.B@HTML'},
            { thumb: 'project/retro-tone-player/retro-tone-player.webp', url: 'project/retro-tone-player/?index=0&maximized=true', title: 'Retro Tone Player'},
            { thumb: 'project/Anemometer.webp', url: 'project/anemometer/?index=0&maximized=true', title: 'Digital Anemometer'},
            { thumb: 'project/wea/Wind_Energy_Resource_Assessment_Tool.webp', url: 'project/wea/?index=0&maximized=true', title: 'Wind Energy Resource Assessment Tool'},
        ]
    },
    {
        organization: 'TagIT Solutions Limited',
        url: 'tagitsol',
        size: 3,
        class: '',
        images: [
            { thumb: 'project/orca-web-and-mobile-app/orca-web-dashboard.webp', url: 'project/orca-web-and-mobile-app?index=0&maximized=true', title: 'ORCA Web & Mobile App'},
            { thumb: 'project/dormbook/dormbook.webp', url: 'project/dormbook?index=0&maximized=true', title: 'Dormitory Room Booking: March back to School'},
        ]
    },
    {
        organization: 'Athena Software Associates',
        url: 'athena',
        size: 4,
        class: '',
        images: [
            { thumb: 'experience/work/athena/20090227133.webp', url: 'work/athena-senior-software-engineer?index=2&maximized=true', title: 'Fun Unlimited'},
            { thumb: 'experience/work/athena/20090805139.webp', url: 'work/athena-senior-software-engineer?index=3&maximized=true', title: 'Visiting a Client Office (UNB)'},
            { thumb: 'experience/work/athena/08112009.webp', url: 'work/athena-senior-software-engineer?index=0&maximized=true', title: 'Random'},
            { thumb: 'experience/work/athena/20091220264.webp', url: 'work/athena-senior-software-engineer?index=1&maximized=true', title: 'Random'},
        ]
    },
    {
        organization: 'Rajshahi Cadet College',
        url: 'rcc',
        size: 5,
        class: '',
        images: [
            { thumb: 'experience/education/rcc/1995-novices-drill-01.webp', url: 'education/ssc?index=0&maximized=true', title: 'Novices Drill 1995'},
            { thumb: 'experience/education/rcc/1995-novices-drill-02.webp', url: 'education/ssc?index=1&maximized=true', title: 'Novices Drill 1995'},
            { thumb: 'experience/education/rcc/1997-group-photo-ix-02.webp', url: 'education/ssc?index=2&maximized=true', title: 'Group Photo IX'},
            { thumb: 'experience/education/rcc/1998-obstacle-cource-class-x.webp', url: 'education/ssc?index=3&maximized=true', title: 'Obstacle Course Class X'},
            { thumb: 'experience/education/rcc/1998-short-excursion-rabindra-kuthibari-kustia.webp', url: 'education/ssc?index=4&maximized=true', title: 'Short Excursion - Rabindra Kuthibari'},
            { thumb: 'experience/education/rcc/1999-group-photo-xi.webp', url: 'education/hsc?index=0&maximized=true', title: 'Group Photo XI'},
            { thumb: 'experience/education/rcc/2001-group-picture.webp', url: 'education/hsc?index=1&maximized=true', title: 'Group Photo XII'},
        ]
    }
];

const colSpanMap = {
    1: 'lg:col-span-1',
    2: 'lg:col-span-2',
    3: 'lg:col-span-3',
    4: 'lg:col-span-4',
    5: 'lg:col-span-5',
    6: 'lg:col-span-6',
    7: 'lg:col-span-7',
    8: 'lg:col-span-8',
    12: 'lg:col-span-12',
};

const accomplishments = [
    {
        text: '<div style="text-align: left;"><a href="/project/automated-404-error-detection-tool">Automated 404 Error Detection Tool</a> to scan & monitor sites.</div><ul><li>High-Prformance with nested multi-threading</li><li>Domain-aware load balancing</li><li>High throughput <small class="text-gray-400"><em>(170+ sites, 14k+ URLs in a remarkably short time)</em></small>.</li></ul>',
        icon: 'work',
        organization: 'OrangeToolz',
        date: '2024',
    },
    {
        text: '<b>Secure Mail Infrastructure:</b> Architected a secure corporate email ecosystem using Postfix and Dovecot, enforcing SPF, DKIM, and DMARC to eliminate 99% of domain spoofing risks',
        icon: 'work',
        organization: 'TagIT Solutions Limited',
        date: '2026',
    },
    {
        text: 'Integrated Network Management (INMS): Developed the <a href="/project/inms">INMS framework</a> featuring real-time monitoring, automated alerts, RBAC, and analytics across Banglalink\'s NOC, Customer Care, and B2B domains',
        icon: 'work',
        organization: 'Banglalink Digital Communications Ltd',
        date: '2010',
    },
    {
        text: '<b>Secure Infrastructure:</b> Engineered secure corporate networks using VLAN, RADIUS, load balancing, VPN, and QoS protocols to support seamless operations',
        icon: 'work',
        organization: 'OrangeToolz',
        date: '2023',
    },
    {
        text: '<b>Cybersecurity Innovation:</b> Developed a custom definition-based <a href="/project/abdullah-virus-removal">Virus Removal Engine</a>, successfully neutralizing complex, multi-layered system threats.',
        icon: null,
        organization: '',
        date: '',
    },
    {
        text: '<b>Hardware-Software Invention:</b> Independently designed and fabricated a custom <a href="/project/anemometer">Digital Anemometer</a> during engineering research.',
        icon: 'school',
        organization: 'Islamic University of Technology',
        date: '2005',
    },
    {
        text: 'Academic Publication: Published peer-reviewed research on the <a href="https://www.ijrer.org/index.php/ijrer/article/view/63" target="_blank"><i>Application of Wind Resource Assessment (WEA) Tool</i></a> in the International Journal of Renewable Energy Research (IJRER).',
        icon: 'school',
        organization: 'Islamic University of Technology',
        date: '2011',
    },
    {
        text: '<b>Cybersecurity Initiative:</b> Safeguarded critical B2B infrastructure, minimizing vulnerability to cyber threats.',
        icon: 'work',
        organization: 'Banglalink Digital Communications Ltd',
        date: '2016',
    },
    {
        text: '<b>Data Pipelines:</b> Optimized media pipelines using FFmpeg format decision logic, reducing video processing overhead by 30%.',
        icon: 'work',
        organization: 'OrangeToolz',
        date: '2023',
    },
    {
        text: '<div style="text-align: left;">Designed <a href="/project/wea">Wind Energy Assessment Tool</a> in M.Sc. Engineering Thesis.</div><ul><li>Calculation of Weibull Parameters</li><li>Energy Estimation of Wind Regimes</li><li>Energy Generated by the Wind Turbine</li><li>Life Cycle  and Financial Analysis</li></ul>',
        icon: 'school',
        organization: 'Islamic University of Technology',
        date: '2007',
    },
    {
        text: 'Accomplished <b>Championship</b> in <b>IUT Programming Contest 2004</b>.',
        icon: 'school',
        organization: 'Islamic University of Technology',
        date: '2004',
    },
    {
        text: 'Created an Innovative Digital Raffle Draw for Banglalink’s employee engagement and family day events, enhancing participation and excitement.',
        icon: 'work',
        organization: 'Banglalink Digital Communications Ltd',
        date: '2016',
    },
];

const tiktokEffectsRoot = [
    {
        id: '7236706908470611201',
        title: 'Card Shuffle',
        url: 'Card-Shuffle-33040299'
    },
    {
        id: '7233849436634483969',
        title: 'Catch the Cat',
        url: 'Catch-the-Cat-30715740'
    },
    {
        id: '7230875692114644225',
        title: 'Coxs Bazar Beach',
        url: 'Coxs-Bazar-Beach-26029810'
    },
    {
        id: '7252394774127332610',
        title: 'Phone Recording',
        url: 'Phone-Recording-33037502'
    },
    {
        id: '7233283971570781442',
        title: 'Anywhere Door',
        url: 'Anywhere-Door-30979804'
    },
    {
        id: '7233203473377021185',
        title: 'Selfie With Cat V2',
        url: 'Selfie-With-Cat-V2-28704551'
    },
    {
        id: '7236756409667407106',
        title: 'Upside Down',
        url: 'Upside-Down-32303323'
    },
    {
        id: '7247196718284950786',
        title: 'Virtual Rain',
        url: 'Virtual-Rain-33037582'
    },
    {
        id: '7235280345447369985',
        title: 'Low Angle Shot',
        url: 'Low-Angle-Shot-32338727'
    },
    {
        id: '7237128450098662658',
        title: 'Auto Rotate Phone',
        url: 'Auto-Rotate-Phone-33153892'
    },
    {
        id: '7245379541944864002',
        title: 'TV VCR Recording',
        url: 'TV-VCR-Recording-33957180'
    },
    {
        id: '7246080183592045825',
        title: 'Movie Theater',
        url: 'Movie-Theater-32322732'
    },
    {
        id: '7246431503528381697',
        title: 'No Signal',
        url: 'No-Signal-36613687'
    },
];

const randomGames = [
    {
        id: 1,
        title: 'Sliding Tiles',
        uri: 'sliding-tiles',
        url: 'SlidingTiles',
        class: '',
        technology: 'ReactJS',
        types: ['number', 'circle', 'flower'],
        minTypeIndex: 1,
        containerClass: ''
    },
    {
        id: 2,
        title: 'Rotating Tiles',
        uri: 'rotating-tiles',
        url: 'RotatingTiles',
        class: '',
        technology: 'ReactJS',
        types: ['number'],
        minTypeIndex: 0,
        containerClass: ''
    },
    {
        id: 3,
        title: 'Rack It Up',
        uri: 'rack-it-up',
        url: 'RackItUp',
        class: 'rackItUp',
        technology: 'ReactJS',
        types: ['alphabet'],
        minTypeIndex: 0,
        containerClass: 'max-w-[900] mx-auto'
    },
    {
        id: 5,
        title: 'Tower of Hanoi',
        uri: 'tower-of-hanoi',
        url: 'TowerOfHanoi',
        class: 'towerOfHanoi',
        technology: 'ReactJS',
        types: [''],
        minTypeIndex: 0,
        containerClass: 'max-w-[900] mx-auto'
    },
    {
        id: 6,
        title: 'Vial of Marbles',
        uri: 'vial-of-marbles',
        url: 'VialOfMarbles',
        class: 'vialOfMarbles',
        technology: 'ReactJS',
        types: [''],
        minTypeIndex: 0,
        containerClass: 'max-w-[900] mx-auto'
    },
    {
        id: 9,
        title: 'Zombie Boom',
        uri: 'zombie-boom',
        url: 'ZombieBoom',
        class: 'zombieBoom',
        technology: 'ReactJS',
        types: ['00:20', '00:30', '00:45'],
        minTypeIndex: 0,
        containerClass: 'max-w-[900] mx-auto'
    },
]

const {
    WorkIcon,
    SchoolIcon,
    CVIcon,
    LinkExternalIcon
} = SvgIcons();

export default function HomePage() {
    const { profile, token, logIn } = useUserAuthentication();
    const [ baseUrl, setBaseUrl ] = useState<string | null>(null);
    const [ scrollPosition, setScrollPosition ] = useState(0);
    const [ width, setWidth ] = useState(0);
    const [ icon, setIcon ] = useState({ width: '30px', height: '30px' });
    const [ displayWorkWithMeSmall, setDisplayWorkWithMeSmall ] = useState(false);
    const [ userAgent, setUserAgent ] = useState('');
    const [ tiktokEffects, setTiktokEffects] = useState<typeof tiktokEffectsRoot>([]);
    const [ gameContainerClassName, setGameContainerClassName] = useState<string>('');
    const [ gameItem, setGameItem] = useState<GameModel | null>(null);
    const [ tileType, setTileType] = useState<string | null>(null);
    const bottomWorkWithMeContainer = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        setBaseUrl(window.location.origin);

        // const ua = navigator.userAgent.toLowerCase();
        // const isSamsungBrowser = ua.includes('samsungbrowser');

        // if (isSamsungBrowser && !localStorage.getItem('samsungDarkToastShown')) {
        //     localStorage.setItem('samsungDarkToastShown', '1');

        //     const message = window.matchMedia('(prefers-color-scheme: dark)').matches
        //         ? 'For best experience, please switch to Light Theme in Samsung Internet.'
        //         : '🌓 It looks like your browser may be applying a dark mode. If some colors look odd or hard to read, try switching your browser or device to Light Mode for the best viewing experience.';

        //     toast.info(message, {
        //         position: "bottom-center",
        //         autoClose: 5000,
        //         hideProgressBar: false,
        //         closeOnClick: false,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //         theme: "colored",
        //         transition: Bounce,
        //     });
        // }
    }, []);


    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setUserAgent(window.navigator.userAgent);
            const gIndex = getRandomNumber(0, randomGames.length-1);
            const cItem = randomGames[gIndex];
            const gItem = {
                id: cItem.id,
                title: cItem.title,
                uri: cItem.uri,
                tagline: cItem.title,
                images: [],
                og_images: [],
                category: 'React',
                url: cItem.url,
                class: cItem.class,
                defaults: null,
                multiplayer: 0,
                default_players: 0,
                min_players: 0,
                max_players: 0,
                player_divisor_remainder: '0',
                github: null,
                description: 'Home Page Game',
                instruction: null,
                technology: cItem.technology,
                displayonlyyear: 1,
                hidedate: 0,
                active: 1,
                published: null,
                dates: null
            };
            setGameItem(gItem);
            setTileType(cItem.types[getRandomNumber(cItem.minTypeIndex, cItem.types.length-1)]);
            setGameContainerClassName(cItem.containerClass);
            if (process.env.NEXT_PUBLIC_DISPLAY_TIKTOK_EFFECT_SHOWCASE === 'true') { // &&  window.navigator.userAgent.includes('Chrome')
                setTiktokEffects(tiktokEffectsRoot);
            }
        }
    }, []);

    useEffect(() => {
        if (scrollPosition > 560) {
            setDisplayWorkWithMeSmall(true);
        } else {
            setDisplayWorkWithMeSmall(false);
        }
    }, [scrollPosition]);

    useEffect(() => {
        handleResize();
    }, []);

    const handleScroll = () => {
        const position = window.scrollY;
        setScrollPosition(position);
    };

    const handleResize = () => {
        setWidth(window.innerWidth);
    }

    const sliderSettings = {
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className="homePage">
            <div className="about">
                <h2>Abdullah Ibne Alam</h2>
                <h3>Crafting Innovative Solutions through Code</h3>
                <div className="prompt">
                    <div className="about-me-summary radial-anim-border">
                        <div className='max-w-[900] mx-auto'>
                            {/* <AnimatedTextWriter delay={50} startDelay={1000} content={', mobile app development, Process Automation and Internet of Things (IoT) solutions.'} prefix="Innovative software developer proficient in crafting full-stack applications" suffix="" displayCodeWrapper={false} displayCursorEnd={false} cursorColor="#999" /> */}
                            Senior Full-Stack Engineer and Solution Architect
                            <ul>
                                <AnimatedTextWriter delay={50} startDelay={500} content={` (React, Next.js, Vue.js)`} prefix={`<li><b>Full-Stack Application Development:</b><br /><div style="margin: 0 0 .5em; font-size: 0.6em">Expert in architecting scalable web applications across modern ecosystems, including Backend (Node.js, NestJS, Laravel, Spring Boot, FastAPI) and Frontend`} suffix={`</div></li>`} displayCodeWrapper={false} displayCursorEnd={false} cursorColor='#666' />
                                <AnimatedTextWriter delay={100} startDelay={600} content={` and Progressive Web Apps <b>(PWA)</b>`} prefix={`<li><b>Mobile & Cross-Platform Development:</b><br /><div style="margin: 0 0 .5em; font-size: 0.6em">Proven expertise in building high-performance mobile applications using <b>Flutter</b>`} suffix={`</div></li>`} displayCodeWrapper={false} displayCursorEnd={false} cursorColor='#666' />
                                <AnimatedTextWriter delay={80} startDelay={500} content={``} prefix={`<li><b>Internet of Things (IoT):</b><br /><div style="margin: 0 0 .5em; font-size: 0.6em">Specialized in IoT solutions, real-time data streaming, and machine-to-machine communication using <b>MQTT</b> protocols`} suffix={`</div></li>`} displayCodeWrapper={false} displayCursorEnd={false} cursorColor='#666' />
                                <AnimatedTextWriter delay={50} startDelay={200} content={``} prefix={`<li><b>Cloud & DevOps (SRE):</b><br /><div style="margin: 0 0 .5em; font-size: 0.6em">AWS (EC2, S3, IAM, Serverless), Kubernetes, Docker, Docker Compose, CI/CD (GitHub Actions), Grafana, Prometheus`} suffix={`</div></li>`} displayCodeWrapper={false} displayCursorEnd={false} cursorColor='#666' />
                            </ul>
                        </div>
                        <div className="absolute right-4 bottom-4 flex flex-row">
                            <Link href="/cv" className="button flex items-center gap-4" prefetch={true} >
                                <CVIcon width='32px' height='32px' style={{ margin: '-10px' }} />
                                View My CV
                            </Link>
                            <Link href="/work-with-me" className="button work-with-me" prefetch={true} >
                                <WorkIcon width='32px' height='32px' style={{ margin: '-10px' }} />
                                Work with Me
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="skillsIconsContainer mb-0!">
                    <div className="skillIconContainerFieldset scooped bg-linear-to-bl from-amber-500/40 to-transparent">
                        <h6>Accomplishments</h6>
                        <div className="grid grid-cols-12 gap-2 ">
                            <div className="col-span-12 lg:col-span-12 px-6 pb-4 prompt">
                                <Slider {...sliderSettings}>
                                    {
                                        accomplishments.map((item, index) => (
                                            <div key={index} className={`accomplishment-item`}>
                                                <div className="accomplishment-content">
                                                    {/* {item.image && <img src={`${baseUrl}${item.image}`} alt={item.organization} style={{ float: 'left', maxWidth: '30%', maxHeight: '100px', opacity:1, borderRadius: 10 }} />} */}
                                                    <div dangerouslySetInnerHTML={{ __html: item.text }}></div>
                                                    {item.icon !== null &&
                                                    <div className='flex items-center justify-center gap-2 mt-6'>
                                                        {item.icon === 'work' ? <WorkIcon width='32px' height='32px' /> : <SchoolIcon width='32px' height='32px' />}
                                                        <p>{item.organization}, {item.date}</p>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        ))
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="skillsIconsContainer">
                    <div className="grid grid-cols-12 gap-2">
                        <div className="col-span-12 lg:col-span-12">
                            <MySkillsOnProgramming width={width} icon={icon} onlyHighlights={true} />
                        </div>
                        <div className="col-span-12 md:col-span-7">
                            <MySkillsOnFrameworksAndLibraries width={width} icon={icon} onlyHighlights={true} />
                        </div>
                         <div className="col-span-12 md:col-span-5">
                            <MySkillsOnWebTechnologies width={width} icon={icon} onlyHighlights={true} />
                        </div>
                        <div className="col-span-12 md:col-span-6">
                            <MySkillsOnDatabases width={width} icon={icon} onlyHighlights={true} />
                        </div>
                        <div className="col-span-12 md:col-span-6">
                            <MySkillsOnCloudAndDevOps width={width} icon={icon} onlyHighlights={true} />
                        </div>
                        <div className="col-span-12 md:col-span-5">
                            <MySkillsOnAIAndAutonomousAgents width={width} icon={icon} onlyHighlights={true} />
                        </div>
                        <div className="col-span-12 md:col-span-7">
                            <MySkillsOnOtherTechnologies width={width} icon={icon} onlyHighlights={true} />
                        </div>
                        {thumbImages.map((org, index) =>
                            <div key={index} className={`col-span-12 ${colSpanMap[org.size as keyof typeof colSpanMap]}`}>
                                <fieldset className={`skillIconContainerFieldset galleryContainer ${org.class}`}>
                                    <legend>{org.organization}</legend>
                                    <div className='galleryThumbContainer'>
                                        <div className="galleryThumbs" style={{ '--image-length' : org.images.length+1, '--size': org.size } as CSSProperties}>
                                            {org.images.toReversed().map((item, index) =>
                                                <Link key={index} href={item.url ? item.url : `experience/${org.url}`} style={{ '--index' : (index as number + 1), zIndex: index} as CSSProperties}>
                                                    <img src={`/media/thumbs/${item.thumb}`} alt={item.title} />
                                                    {item.title && <div className='infoContainer'><div className='info'>{item.title}</div></div>}
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                    <Link className="absolute -bottom-0.5 right-0.75" href={`experience/${org.url}`} title={`View all Experiences at ${org.organization}`}><LinkExternalIcon width='16px' height='16px' /></Link>
                                </fieldset>
                            </div>
                        )}
                        {tiktokEffects.length > 0 && (
                        <div className="col-span-12 lg:col-span-12">
                            <fieldset className="skillIconContainerFieldset galleryContainer portrait" style={{ animationDuration: '1.8s !important' }}>
                                <legend>Showcase: TikTok Effects by Me</legend>
                                <div className='galleryThumbContainer'>
                                    <div className="galleryThumbs" style={{ '--image-length' : tiktokEffects.length+1, '--size': 12 } as CSSProperties}>
                                        {tiktokEffects.toReversed().map((item, index) =>
                                            <Link key={index} href={`https://www.tiktok.com/@repulsivecoder/video/${item.id}`} style={{ '--index' : (index as number + 1), zIndex: index} as CSSProperties} target='_blank'>
                                                <img src={`/media/thumbs/effects/${item.id}.webp`} alt={item.url} />
                                                <div className='infoContainer'>
                                                    <div className='info'>
                                                        <div key={index} onClick={(e) => { e.preventDefault(); window.open(`https://www.tiktok.com/effect/${item.url}`); }}> {item.title}</div>
                                                    </div>
                                                </div>
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        )}
                        {/* <div className="col-span-12 lg:col-span-12" id='css-solar-animation'>
                            <fieldset className="skillIconContainerFieldset solarSystemFieldset">
                                <SolarSync item={{ title: 'SolarSync: Animated Planetary System' } as ProjectModel} />
                            </fieldset>
                        </div> */}
                    </div>
                </div>
            </div>
            {/* {tileType !== null && <GameSlidingTiles gridSize={3} profile={profile} logIn={logIn} token={token} type={tileType} /> } */}
            <div className={gameContainerClassName}>
                {gameItem !== null && <LoadGameComponent item={gameItem} home={true} gridSize={3} type={tileType} profile={profile} logIn={logIn} token={token} /> }
            </div>
            {isMobile && (
            <div style={{ width: 'calc(100% - 10px)', marginBottom: 40 }}>
                <Link href="/projects" prefetch={true} className="button outlined" style={{ float: 'right'}}>
                    Project <span className="symbol next">&raquo;</span>
                </Link>
            </div>
            )}
            {process.env.NEXT_PUBLIC_DISPLAY_TOPTAL_HIRE_ME === 'true' && (
                <div className={`mt-8 mb-6 lg:mt-0 lg:mb-0 mx-auto w-54 lg:fixed lg:right-15 lg:bottom-20 transition-all duration-1000 z-500`}>
                    <ToptalHireMe />
                </div>
            )}
            <div className={`fixed right-5 bottom-6 ${displayWorkWithMeSmall ? '' : 'opacity-0 pointer-events-none'} transition-all duration-1000 z-200`}
                ref={bottomWorkWithMeContainer}
            >
                <Link
                    href={`/work-with-me?url=${encodeURIComponent(baseUrl??'')}`}
                    className={` button mx-auto! gap-6! work-with-me-small`}
                    prefetch={true}
                >
                    <WorkIcon width='32px' height='32px' style={{ margin: '-10px' }} />
                    Like what you see? → Work with Me
                </Link>
            </div>
        </div>
    );
}
